import React from "react";
import { useT, Namespace } from "@racoon/i18n";
import { cn } from "@racoon/ui";
import type { ContainerViewStatus } from "../../model/container.filters";

// Figma "Container Status" chip: on_PL → Surface/success_light + Border/success +
// Text/success; in_depo → Surface/Tertiary + Border/disabled + Text/secondary;
// archived → Surface/error_light + Border/error + Text/error.
const STATUS_CLASSES: Record<ContainerViewStatus, string> = {
  delivered: "border-green-500 bg-green-100 text-green-600",
  collected: "border-slate-300 bg-slate-200 text-text-subtle",
  archived: "border-red-500 bg-surface-error-light text-text-error",
};

export const CONTAINER_STATUS_LABEL_KEY = {
  delivered: "inventory.status.delivered",
  collected: "inventory.status.collected",
  archived: "inventory.status.archived",
} as const satisfies Record<ContainerViewStatus, string>;

interface SecondaryStatusBadgeProps {
  status: ContainerViewStatus;
  className?: string;
}

/**
 * The outlined ("secondary") status chip: tinted surface, matching border and
 * text. Only containers use it for now; the shared status pill is to take it
 * over as its outlined variant.
 */
export const SecondaryStatusBadge: React.FC<SecondaryStatusBadgeProps> = ({
  status,
  className,
}) => {
  const t = useT();
  return (
    <span
      className={cn(
        "inline-flex h-6 shrink-0 items-center justify-center whitespace-nowrap rounded-lg border px-2 py-1 text-xs font-medium leading-4 tracking-[-0.01em]",
        STATUS_CLASSES[status],
        className,
      )}
    >
      {t(Namespace.Settings, CONTAINER_STATUS_LABEL_KEY[status])}
    </span>
  );
};
